import Alpine from "alpinejs";

type NavTarget = {
    id: string;
    label: string;
};

// Placeholder marker attribute; rename once the Inkscape attribute is decided.
const NAV_TARGET_ATTR = 'data-nav-target';

Alpine.data('nav', () => ({
    targets: [] as NavTarget[],
    init() {
        const svgRoot = document.querySelector<SVGGElement>('#main')?.ownerSVGElement;
        if (!svgRoot) {
            return;
        }

        this.targets = [...svgRoot.querySelectorAll(`[${NAV_TARGET_ATTR}]`)]
            .filter(el => el.id)
            .map(el => ({
                id: el.id,
                label: el.getAttribute(NAV_TARGET_ATTR)?.trim() || el.id,
            }));
    },

    visit(id: string) {
        this.$dispatch('viewport-goto', { id });
    },
}));
